// Copyright 2005-2011 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var dom   = require('./dom'), timeout=dom.timeout, URL=dom.URL, Deferral=dom.Deferral;
var lib   = require('./lib'), merge_into=lib.merge_into, map=lib.map;
var plat  = require('./platform');
var Prefs = require('./prefs');
var prnt  = require('./print'), printf=prnt.printf;
var piles = require('./piles'), up=piles.up, down=piles.down, clubs=piles.clubs, diamonds=piles.diamonds, hearts=piles.hearts, spades=piles.spades,
                              ace=piles.ace, jack=piles.jack, queen=piles.queen, king=piles.king, joker=piles.joker, base64=piles.base64,
                              card=piles.card, init_deck=piles.init_deck;
var card_holiday = require('./card-holiday.json');
var card_theme = require('./card-theme.json');
var card_size  = require('./card-size.json');
var card_back  = require('./card-back.json');

class pile_game_ui {
    constructor(game) {

        this.game = game;

        function date_is(month,day) {
            var d = new Date();
            return d.getMonth()+1 == month && d.getDate() == day;
        }
        function day_of_year(month, day) {
            return (new Date((new Date()).getFullYear(), month, day)).getTime() / 1000/60/60/24 -
                   (new Date((new Date()).getFullYear(), 1,     1  )).getTime() / 1000/60/60/24;
        }
        function date_is_between(...ranges) {
            var d = new Date();
            var now = day_of_year(d.getMonth()+1, d.getDate());
            for (var [month1, day1, month2,day2, year] of ranges) {
                if (day_of_year(month1, day1) <= now && now <= day_of_year(month2, day2) && (!year || year == d.getFullYear()))
                    return true;
            }
            return false;
        }

        var holiday = Object.entries(card_holiday).filter(([_name, config]) =>
            config.date       && date_is        .apply(this, config.date) ||
            config.date_range && date_is_between.apply(this, config.date_range)
        ).map(([name, config])=> ({ holiday: name, enabled: true, ...config }));

        // If there's more than one holiday today, pick a random one.
        this.holiday = holiday = holiday.length > 0 ? holiday[Math.floor(Math.random() * holiday.length)] : undefined;

        (function init_cardsets() {
            this.cardsets = {};
            for (var [theme, ct] of Object.entries(card_theme)) {
                if (ct["default"]) this.default_theme = theme;
                var theme_size = {};
                for (var size in card_size)
                    theme_size[size] = merge_into({ size:size, theme:theme }, card_size[size]);
                this.cardsets[theme] = theme_size;
            }
            this.theme = URL.param.theme || (this.holiday && this.holiday.theme) || Prefs.v.cardtheme || this.default_theme;
        }).call(this);

        this.cardset_default = this.cardsets[this.theme][URL.param.cardset || Prefs.v.cardset];
        this.cardset = this.cardset_default || { width: 1, height: 1, size: "unit-size", theme: "autosize" }; // piles-ui sets this to something reasonable after it autosizes.

        function Cardbacks() {
            this.cardback = {};
            if (Prefs.v.cardback) {
                var backs = Prefs.v.cardback.split(',');
                for(let b of backs)
                  if (card_back[b]) // Filter out cardbacks we've removed
                    this.cardback[b] = true;
            }
        }
        Cardbacks.prototype.set = function(back, enabled) {
            if (enabled !== undefined)
                if (enabled)
                    this.cardback[back] = true;
                else
                    delete this.cardback[back];
            Prefs.set("cardback", Object.keys(this.cardback).sort().join(',') || undefined);
            return this.cardback[back];
        }
        Cardbacks.prototype.random = function() {
            var a = this.allowed();
            return a[Math.floor(Math.random() * a.length)];
        }
        Cardbacks.prototype.allowed = function() {
            var backs = Object.keys(this.cardback);
            if (backs.length == 0)
                backs = Object.keys(card_back);
            return holiday && holiday.back && holiday.enabled ? [holiday.back] : backs
        }

        this.cardbacks = new Cardbacks;
        window.piwik_vars.push(['setCustomVariable', 3, "Card Back", card_back[this.cardbacks.random()].name]);

        this.piles = {};
        this.all_cards = [];
        this.all_decks = [];
        this.animation_frame_callbacks = [];

        plat.register_key_events(document.body, this.card_finder_key_handler.bind(this), "keyup", "keydown");
    }

    resolve_grid(grid) { // tries to match names in the grid definition with their corresponding piles (which may not be instantiated yet).
            var rgrid = [];
            for (var r=0; r<grid.length; r++) {
                rgrid[r] = [];
                for (var c=0; c<grid[r].length; c++) {
                    if (grid[r][c] == void 0) continue;
                    if (typeof grid[r][c] == "string") {
                        if (this.piles[grid[r][c]])
                            rgrid[r][c] = this.piles[grid[r][c]];
                        else if (window.debug)
                            printf("Missing pile: %s\n", grid[r][c]);
                    } else
                        rgrid[r][c] = grid[r][c];
                }
            }
            return rgrid;
    }

    unit_size_layout(rgrid) {
            var horizontal_padding = .05;
            var vertical_padding   = .05;

            var play_area = { width: 0, height: 0 };
            var piles = [];

            var y=0;
            for (var r=0; r<rgrid.length; r++) {
                var x=0;
                for (var c=0; c<rgrid[r].length; c++) {
                    if (rgrid[r][c] && rgrid[r][c].constructor == Object) {
                        y += rgrid[r][c].y || 0;
                        x += rgrid[r][c].x || 0;
                        if ('padding' in rgrid[r][c])
                            if (typeof rgrid[r][c].padding == "number")
                                horizontal_padding = vertical_padding = rgrid[r][c].padding;
                        else {
                            if ('x' in rgrid[r][c].padding)
                                horizontal_padding = rgrid[r][c].padding.x;
                            if ('y' in rgrid[r][c].padding)
                                vertical_padding = rgrid[r][c].padding.y;
                        }
                        continue;
                    }

                    if (rgrid[r][c] != void 0) {
                        rgrid[r][c].ui.coords = { x:x, y:y };
                        play_area.width  = Math.max(play_area.width,  x+(rgrid[r][c].ui.size||{width: 0}).width);
                        play_area.height = Math.max(play_area.height, y+(rgrid[r][c].ui.size||{height:0}).height);
                    }
                    x += 1 + horizontal_padding;
                }
                y += 1 + vertical_padding;
            }

            return play_area;
    }

    request_lay_out() {
            if (!this.layout_deferral)
                this.layout_deferral = new Deferral(() => this.lay_out());

            this.layout_deferral.defer();
    }
    lay_out_now() { this.layout_deferral.run() }
    lay_out() {
                    let prev_grid = this.grid;
                    this.grid = this.game_layout().grid;
                    if (!this.rgrid || this.grid != prev_grid)
                        this.rgrid = this.resolve_grid(this.grid);
                    this.size = this.unit_size_layout(this.rgrid);
                    if (this.cardset.theme == "autosize")
                        this.update_cardset(this.cardset = this.best_cardset(this.cardsets[this.theme]));
                    else
                        this.update_card_sizes_and_positions();
    }

    game_layout() {
            if (this.game.layout.constructor === Array)
                return this.find_layout(this.game.layout);
            // Old way: Only portrait and landscape via hardcoded keys
            return this.game.layout ||
                (this.content_size().width > this.content_size().height
                 ? this.game.layout_landscape
                 : this.game.layout_portrait);
    }

    // New way: Go through all our layouts, find the first one that matches some constraints (aspect ratio, mobile, etc)
    find_layout(layouts) { throw "abstractish base class" }

    update_card_sizes_and_positions() { throw "abstractish base class" }

    content_size() { throw "abstractish base class" }

    best_cardset(cardsets) {
            var best, content_size = this.content_size();
            var sorted_cardsets = map(function(c) { return { cardset: c,
                                                             width:  this.size.width * c.width,
                                                             height: this.size.height * c.height }
                                                  }.bind(this), cardsets).sort(function(a,b) { return a.width - b.width; });
            for (var i in sorted_cardsets) {
                if (!best || sorted_cardsets[i].width < content_size.width
                          && sorted_cardsets[i].height < content_size.height)
                    best = sorted_cardsets[i];
            }
            return best.cardset;
    }

    update_cardset(cardset) {
            this.cardset = cardset;
            this.game.redraw();
            for (var i=0; i<this.all_cards.length; i++) {
                this.all_cards[i].ui.update_cardset(this.cardset);
                this.all_cards[i].ui.recreate();
            }
            this.update_card_sizes_and_positions();
    }

    backs_visible(backs_are_visible) { throw "abstractish base class" }

    card_finder_key_handler = (function() {
        let suit,red,rank;
        return function(event) {
            if (this.game.is_paused())
                return;
            var k = event.key.toUpperCase();
            var held = event.type == "keydown";

            switch(k) {
                case "C": suit = held ? clubs    : void 0; red = void 0; break;
                case "D": suit = held ? diamonds : void 0; red = void 0; break;
                case "H": suit = held ? hearts   : void 0; red = void 0; break;
                case "S": suit = held ? spades   : void 0; red = void 0; break;

                case "R": suit = void 0;   red = held ? true  : void 0;  break;
                case "B": suit = void 0;   red = held ? false : void 0;  break;

                case "A":
                case "1": rank = held ? ace   : void 0; break;
                case "2": rank = held ? 2     : void 0; break;
                case "3": rank = held ? 3     : void 0; break;
                case "4": rank = held ? 4     : void 0; break;
                case "5": rank = held ? 5     : void 0; break;
                case "6": rank = held ? 6     : void 0; break;
                case "7": rank = held ? 7     : void 0; break;
                case "8": rank = held ? 8     : void 0; break;
                case "9": rank = held ? 9     : void 0; break;
                case "0":
                case "T": rank = held ? 10    : void 0; break;
                case "J": rank = held ? jack  : void 0; break;
                case "Q": rank = held ? queen : void 0; break;
                case "K": rank = held ? king  : void 0; break;
                case "O": rank = held ? joker : void 0; break;
                default:  rank = suit = red = void 0; return;
            }

            for (var p in this.piles)
                for (var i in this.piles[p].pile) {
                    var card = this.piles[p].pile[i];
                    if (card.face == up)
                        if ((red == void 0 || red == card.red) && (rank == void 0 || rank == card.rank) && (suit == void 0 || suit == card.suit))
                            this.piles[p].pile[i].ui.set_opacity(1, 1);
                        else
                            this.piles[p].pile[i].ui.set_opacity(.25, 1);
                }

            return false;
    }})();

    set_opacity(percent) {
            this.opacity = percent;
            for (var i in this.game.piles) {
                if (this.game.piles[i].icon)
                    this.game.piles[i].icon.ui.set_opacity(percent, percent);
                for (var c in this.game.piles[i].pile)
                    this.game.piles[i].pile[c].ui.set_opacity(percent, percent);
            }
    }

    on_pause() { throw "abstractish base class" }
    on_unpause() { throw "abstractish base class" }

    cardset_pixels(d) { return d*this.cardset.width/90; } // as long as the aspect ratio is the same it doesn't matter if we use width or height

    add_card(card) {
            this.all_cards.push(card);
            this.add_deck(card.deck);
    }

    add_deck(deck) {
            if (!deck || deck.seen) return;
            this.all_decks.push(deck);
            deck.seen = true;
            deck.design = this.cardbacks.random();
    }

    update_cardbacks() {
            var design;
            for (var d in this.all_decks)
                this.all_decks[d].design = this.cardbacks.random();
            for (var c in this.all_cards)
                this.all_cards[c].ui.redraw();
    }

    find_pile(unit_position) {
            for (var p in this.piles) {
                var ps = this.piles[p].ui.coords;
                var pe = this.piles[p].coords(this.piles[p].top_index());
                if (ps.x <= unit_position.x && unit_position.x <= ps.x + pe.x + 1 &&
                    ps.y <= unit_position.y && unit_position.y <= ps.y + pe.y + 1)
                    return this.piles[p];
            }
            return void 0;
    }

    // Batching all the callbacks up doesn't matter in the browser. This is only here for piles-ui.canvas and piles-ui.webgl:
    request_animation_frame(callback) {
            if (this.animation_frame_callbacks.length == 0)
                dom.animate_next_frame(this.animation_frame.bind(this));
            return this.animation_frame_callbacks.push(callback) - 1;
    }
    cancel_animation_frame(id) {
            delete this.animation_frame_callbacks[id];
    }
    animation_frame(elapsed) {
            var callbacks = this.animation_frame_callbacks;
            this.animation_frame_callbacks = [];
            for (var c in callbacks)
                if (callbacks[c])
                    callbacks[c](elapsed);
    }

    game_restored() { throw "abstractish base class" }
}

class pile_ui {
    constructor(name, pile) {
        this.pile = pile;
        pile.game.ui.piles[name] = pile;
    }
    set_size(width, height) {
            if (this.size &&
                this.size.width == width &&
                this.size.height == height)
                return;
            this.size = { width: width, height: height };
            this.pile.game.ui.request_lay_out();
    }

    update() { throw "abstractish base class" }
    set_drag_start_handler(handler) { throw "abstractish base class" }
    set_drag_handler(handler) { throw "abstractish base class" }
    set_drag_end_handler(handler) { throw "abstractish base class" }
    drag_complete() { throw "abstractish base class" }
}

class card_ui {
    constructor(card, game) {
        this.card = card;
        this.game = game;
        this.game.ui.add_card(card);
        this.cardset = this.game.ui.cardset;
        this.update_face();
    }

    recreate() {
            this.redraw();
            this.update_face("force");
    }

    update_face(force) {
            if (this.img_face != this.card.face || force)
                this.set_face(this.img_face = this.card.face);
    }

    set_design(design) {
            this.card.design = design;
            this.redraw();
    }

    update_cardset(cardset) {
            this.set_cardset(cardset);
    }

    draw(pile_ui, coords, dz, animate) {
            if (this.animate != animate) return; // don't let piles update while animating
            this.coords = coords;
            this.update_face();
            this.set_position(pile_ui, {x:coords.x, y:coords.y, z:coords.z+(dz||0)}, !!animate);
            this.show();
            this.pile_ui = pile_ui;
    }

    coords_relative_to(pile_ui, dest_coords) {
            var c = this.coords, f = this.pile_ui.coords, t = pile_ui.coords;
            return { x: c.x + f.x - t.x, y: c.y + f.y - t.y, z: dest_coords.z };
    }


    animate_to(pile, offset, dz, callback) {
            var animating = this.animate;
            this.animate = { pile: pile, offset: offset, dz: dz||0, callback: (animating ? animating.callback : []).concat(callback ? [callback] : []) };
            if (animating) return;
            var next_frame = function(me, elapsed) {
                var d = me.animate, dc = me.animate.pile.coords(d.offset);
                if (me.pile_ui != me.animate.pile.ui)
                    me.draw(me.animate.pile.ui, me.coords_relative_to(me.animate.pile.ui, dc), 100+dz, me.animate); // switch to new pile without moving
                var dx = dc.x - me.coords.x, dy = dc.y - me.coords.y, r = 8 * Math.LN2 / 1000 / .250, rt = (r*elapsed)/(1+r*elapsed); // Backwards Euler
                if (Math.abs(dx) < 2/90 && Math.abs(dy) < 2/130) {
                    callback = me.animate.callback;
                    delete me.animate;
                    me.draw(d.pile.ui, dc, d.dz);
                    for (let c in callback) callback[c]();
                } else {
                    me.draw(d.pile.ui, { x: me.coords.x + rt * dx, y: me.coords.y + rt * dy, z: me.coords.z }, 100+d.dz, me.animate);
                    me.id = me.game.ui.request_animation_frame(function(elapsed) {
                        delete me.id;
                        next_frame(me, elapsed);
                    });
                }
            }

            next_frame(this, 0);
    }

    cancel_animation() {
            if (this.id != undefined) { this.game.ui.cancel_animation_frame(this.id); delete this.id }
            delete this.animate;
    }

    erase() {
            this.hide();
    }

    // Backend stuff:
    redraw() { throw "abstractish base class" }
    set_opacity(front, back) {  throw "abstractish base class" }
    set_face(face) { throw "abstractish base class" }
    hide() { throw "abstractish base class" }
    show() { throw "abstractish base class" }
    set_cardset(cardset) { throw "abstractish base class" }
    set_position(pile_ui, coords, animating) { throw "abstractish base class" }
    set_cursor(cursor) { throw "abstractish base class" }
}

function grid() {
    // Deep copy the grid from out of arguments.
    var g = []
    for (var r=0; r<arguments.length; r++)
        g[r] = arguments[r].slice();
    return { grid: g };
}

module.exports = {
    pile_game_ui: pile_game_ui,
    pile_ui: pile_ui,
    card_ui: card_ui,
    grid: grid,
    aspect: { 'phone_landscape' : 2/1,
              'phone_portrait'  : 1/2,
              'tablet_landscape': 3/4,
              'tablet_portrait' : 4/3, },
};
// Copyright 2005-2011 Jim Radford <radford@blackbean.org>, David Caldwell <david@porkrind.org>

var dom   = require('./dom'), timeout=dom.timeout, URL=dom.URL, Deferral=dom.Deferral;
var lib   = require('./lib'), merge_into=lib.merge_into, map=lib.map;
var plat  = require('./platform');
var Prefs = require('./prefs');
var prnt  = require('./print'), printf=prnt.printf;
var piles = require('./piles'), up=piles.up, down=piles.down, clubs=piles.clubs, diamonds=piles.diamonds, hearts=piles.hearts, spades=piles.spades,
                              ace=piles.ace, jack=piles.jack, queen=piles.queen, king=piles.king, joker=piles.joker, base64=piles.base64,
                              card=piles.card, init_deck=piles.init_deck;
var card_holiday = require('./card-holiday.json');
var card_theme = require('./card-theme.json');
var card_size  = require('./card-size.json');
var card_back  = require('./card-back.json');

class pile_game_ui {
    constructor(game) {

        this.game = game;

        function date_is(month,day) {
            var d = new Date();
            return d.getMonth()+1 == month && d.getDate() == day;
        }
        function day_of_year(month, day) {
            return (new Date((new Date()).getFullYear(), month, day)).getTime() / 1000/60/60/24 -
                   (new Date((new Date()).getFullYear(), 1,     1  )).getTime() / 1000/60/60/24;
        }
        function date_is_between(...ranges) {
            var d = new Date();
            var now = day_of_year(d.getMonth()+1, d.getDate());
            for (var [month1, day1, month2,day2, year] of ranges) {
                if (day_of_year(month1, day1) <= now && now <= day_of_year(month2, day2) && (!year || year == d.getFullYear()))
                    return true;
            }
            return false;
        }

        var holiday = Object.entries(card_holiday).filter(([_name, config]) =>
            config.date       && date_is        .apply(this, config.date) ||
            config.date_range && date_is_between.apply(this, config.date_range)
        ).map(([name, config])=> ({ holiday: name, enabled: true, ...config }));

        // If there's more than one holiday today, pick a random one.
        this.holiday = holiday = holiday.length > 0 ? holiday[Math.floor(Math.random() * holiday.length)] : undefined;

        (function init_cardsets() {
            this.cardsets = {};
            for (var [theme, ct] of Object.entries(card_theme)) {
                if (ct["default"]) this.default_theme = theme;
                var theme_size = {};
                for (var size in card_size)
                    theme_size[size] = merge_into({ size:size, theme:theme }, card_size[size]);
                this.cardsets[theme] = theme_size;
            }
            this.theme = URL.param.theme || (this.holiday && this.holiday.theme) || Prefs.v.cardtheme || this.default_theme;
        }).call(this);

        this.cardset_default = this.cardsets[this.theme][URL.param.cardset || Prefs.v.cardset];
        this.cardset = this.cardset_default || { width: 1, height: 1, size: "unit-size", theme: "autosize" }; // piles-ui sets this to something reasonable after it autosizes.

        function Cardbacks() {
            this.cardback = {};
            if (Prefs.v.cardback) {
                var backs = Prefs.v.cardback.split(',');
                for(let b of backs)
                  if (card_back[b]) // Filter out cardbacks we've removed
                    this.cardback[b] = true;
            }
        }
        Cardbacks.prototype.set = function(back, enabled) {
            if (enabled !== undefined)
                if (enabled)
                    this.cardback[back] = true;
                else
                    delete this.cardback[back];
            Prefs.set("cardback", Object.keys(this.cardback).sort().join(',') || undefined);
            return this.cardback[back];
        }
        Cardbacks.prototype.random = function() {
            var a = this.allowed();
            return a[Math.floor(Math.random() * a.length)];
        }
        Cardbacks.prototype.allowed = function() {
            var backs = Object.keys(this.cardback);
            if (backs.length == 0)
                backs = Object.keys(card_back);
            return holiday && holiday.back && holiday.enabled ? [holiday.back] : backs
        }

        this.cardbacks = new Cardbacks;
        window.piwik_vars.push(['setCustomVariable', 3, "Card Back", card_back[this.cardbacks.random()].name]);

        this.piles = {};
        this.all_cards = [];
        this.all_decks = [];
        this.animation_frame_callbacks = [];

        plat.register_key_events(document.body, this.card_finder_key_handler.bind(this), "keyup", "keydown");
    }

    resolve_grid(grid) { // tries to match names in the grid definition with their corresponding piles (which may not be instantiated yet).
            var rgrid = [];
            for (var r=0; r<grid.length; r++) {
                rgrid[r] = [];
                for (var c=0; c<grid[r].length; c++) {
                    if (grid[r][c] == void 0) continue;
                    if (typeof grid[r][c] == "string") {
                        if (this.piles[grid[r][c]])
                            rgrid[r][c] = this.piles[grid[r][c]];
                        else if (window.debug)
                            printf("Missing pile: %s\n", grid[r][c]);
                    } else
                        rgrid[r][c] = grid[r][c];
                }
            }
            return rgrid;
    }

    unit_size_layout(rgrid) {
            var horizontal_padding = .05;
            var vertical_padding   = .05;

            var play_area = { width: 0, height: 0 };
            var piles = [];

            var y=0;
            for (var r=0; r<rgrid.length; r++) {
                var x=0;
                for (var c=0; c<rgrid[r].length; c++) {
                    if (rgrid[r][c] && rgrid[r][c].constructor == Object) {
                        y += rgrid[r][c].y || 0;
                        x += rgrid[r][c].x || 0;
                        if ('padding' in rgrid[r][c])
                            if (typeof rgrid[r][c].padding == "number")
                                horizontal_padding = vertical_padding = rgrid[r][c].padding;
                        else {
                            if ('x' in rgrid[r][c].padding)
                                horizontal_padding = rgrid[r][c].padding.x;
                            if ('y' in rgrid[r][c].padding)
                                vertical_padding = rgrid[r][c].padding.y;
                        }
                        continue;
                    }

                    if (rgrid[r][c] != void 0) {
                        rgrid[r][c].ui.coords = { x:x, y:y };
                        play_area.width  = Math.max(play_area.width,  x+(rgrid[r][c].ui.size||{width: 0}).width);
                        play_area.height = Math.max(play_area.height, y+(rgrid[r][c].ui.size||{height:0}).height);
                    }
                    x += 1 + horizontal_padding;
                }
                y += 1 + vertical_padding;
            }

            return play_area;
    }

    request_lay_out() {
            if (!this.layout_deferral)
                this.layout_deferral = new Deferral(() => this.lay_out());

            this.layout_deferral.defer();
    }
    lay_out_now() { this.layout_deferral.run() }
    lay_out() {
                    let prev_grid = this.grid;
                    this.grid = this.game_layout().grid;
                    if (!this.rgrid || this.grid != prev_grid)
                        this.rgrid = this.resolve_grid(this.grid);
                    this.size = this.unit_size_layout(this.rgrid);
                    if (this.cardset.theme == "autosize")
                        this.update_cardset(this.cardset = this.best_cardset(this.cardsets[this.theme]));
                    else
                        this.update_card_sizes_and_positions();
    }

    game_layout() {
            if (this.game.layout.constructor === Array)
                return this.find_layout(this.game.layout);
            // Old way: Only portrait and landscape via hardcoded keys
            return this.game.layout ||
                (this.content_size().width > this.content_size().height
                 ? this.game.layout_landscape
                 : this.game.layout_portrait);
    }

    // New way: Go through all our layouts, find the first one that matches some constraints (aspect ratio, mobile, etc)
    find_layout(layouts) { throw "abstractish base class" }

    update_card_sizes_and_positions() { throw "abstractish base class" }

    content_size() { throw "abstractish base class" }

    best_cardset(cardsets) {
            var best, content_size = this.content_size();
            var sorted_cardsets = map(function(c) { return { cardset: c,
                                                             width:  this.size.width * c.width,
                                                             height: this.size.height * c.height }
                                                  }.bind(this), cardsets).sort(function(a,b) { return a.width - b.width; });
            for (var i in sorted_cardsets) {
                if (!best || sorted_cardsets[i].width < content_size.width
                          && sorted_cardsets[i].height < content_size.height)
                    best = sorted_cardsets[i];
            }
            return best.cardset;
    }

    update_cardset(cardset) {
            this.cardset = cardset;
            this.game.redraw();
            for (var i=0; i<this.all_cards.length; i++) {
                this.all_cards[i].ui.update_cardset(this.cardset);
                this.all_cards[i].ui.recreate();
            }
            this.update_card_sizes_and_positions();
    }

    backs_visible(backs_are_visible) { throw "abstractish base class" }

    card_finder_key_handler = (function() {
        let suit,red,rank;
        return function(event) {
            if (this.game.is_paused())
                return;
            var k = event.key.toUpperCase();
            var held = event.type == "keydown";

            switch(k) {
                case "C": suit = held ? clubs    : void 0; red = void 0; break;
                case "D": suit = held ? diamonds : void 0; red = void 0; break;
                case "H": suit = held ? hearts   : void 0; red = void 0; break;
                case "S": suit = held ? spades   : void 0; red = void 0; break;

                case "R": suit = void 0;   red = held ? true  : void 0;  break;
                case "B": suit = void 0;   red = held ? false : void 0;  break;

                case "A":
                case "1": rank = held ? ace   : void 0; break;
                case "2": rank = held ? 2     : void 0; break;
                case "3": rank = held ? 3     : void 0; break;
                case "4": rank = held ? 4     : void 0; break;
                case "5": rank = held ? 5     : void 0; break;
                case "6": rank = held ? 6     : void 0; break;
                case "7": rank = held ? 7     : void 0; break;
                case "8": rank = held ? 8     : void 0; break;
                case "9": rank = held ? 9     : void 0; break;
                case "0":
                case "T": rank = held ? 10    : void 0; break;
                case "J": rank = held ? jack  : void 0; break;
                case "Q": rank = held ? queen : void 0; break;
                case "K": rank = held ? king  : void 0; break;
                case "O": rank = held ? joker : void 0; break;
                default:  rank = suit = red = void 0; return;
            }

            for (var p in this.piles)
                for (var i in this.piles[p].pile) {
                    var card = this.piles[p].pile[i];
                    if (card.face == up)
                        if ((red == void 0 || red == card.red) && (rank == void 0 || rank == card.rank) && (suit == void 0 || suit == card.suit))
                            this.piles[p].pile[i].ui.set_opacity(1, 1);
                        else
                            this.piles[p].pile[i].ui.set_opacity(.25, 1);
                }

            return false;
    }})();

    set_opacity(percent) {
            this.opacity = percent;
            for (var i in this.game.piles) {
                if (this.game.piles[i].icon)
                    this.game.piles[i].icon.ui.set_opacity(percent, percent);
                for (var c in this.game.piles[i].pile)
                    this.game.piles[i].pile[c].ui.set_opacity(percent, percent);
            }
    }

    on_pause() { throw "abstractish base class" }
    on_unpause() { throw "abstractish base class" }

    cardset_pixels(d) { return d*this.cardset.width/90; } // as long as the aspect ratio is the same it doesn't matter if we use width or height

    add_card(card) {
            this.all_cards.push(card);
            this.add_deck(card.deck);
    }

    add_deck(deck) {
            if (!deck || deck.seen) return;
            this.all_decks.push(deck);
            deck.seen = true;
            deck.design = this.cardbacks.random();
    }

    update_cardbacks() {
            var design;
            for (var d in this.all_decks)
                this.all_decks[d].design = this.cardbacks.random();
            for (var c in this.all_cards)
                this.all_cards[c].ui.redraw();
    }

    find_pile(unit_position) {
            for (var p in this.piles) {
                var ps = this.piles[p].ui.coords;
                var pe = this.piles[p].coords(this.piles[p].top_index());
                if (ps.x <= unit_position.x && unit_position.x <= ps.x + pe.x + 1 &&
                    ps.y <= unit_position.y && unit_position.y <= ps.y + pe.y + 1)
                    return this.piles[p];
            }
            return void 0;
    }

    // Batching all the callbacks up doesn't matter in the browser. This is only here for piles-ui.canvas and piles-ui.webgl:
    request_animation_frame(callback) {
            if (this.animation_frame_callbacks.length == 0)
                dom.animate_next_frame(this.animation_frame.bind(this));
            return this.animation_frame_callbacks.push(callback) - 1;
    }
    cancel_animation_frame(id) {
            delete this.animation_frame_callbacks[id];
    }
    animation_frame(elapsed) {
            var callbacks = this.animation_frame_callbacks;
            this.animation_frame_callbacks = [];
            for (var c in callbacks)
                if (callbacks[c])
                    callbacks[c](elapsed);
    }

    game_restored() { throw "abstractish base class" }
}

class pile_ui {
    constructor(name, pile) {
        this.pile = pile;
        pile.game.ui.piles[name] = pile;
    }
    set_size(width, height) {
            if (this.size &&
                this.size.width == width &&
                this.size.height == height)
                return;
            this.size = { width: width, height: height };
            this.pile.game.ui.request_lay_out();
    }

    update() { throw "abstractish base class" }
    set_drag_start_handler(handler) { throw "abstractish base class" }
    set_drag_handler(handler) { throw "abstractish base class" }
    set_drag_end_handler(handler) { throw "abstractish base class" }
    drag_complete() { throw "abstractish base class" }
}

class card_ui {
    constructor(card, game) {
        this.card = card;
        this.game = game;
        this.game.ui.add_card(card);
        this.cardset = this.game.ui.cardset;
        this.update_face();
    }

    recreate() {
            this.redraw();
            this.update_face("force");
    }

    update_face(force) {
            if (this.img_face != this.card.face || force)
                this.set_face(this.img_face = this.card.face);
    }

    set_design(design) {
            this.card.design = design;
            this.redraw();
    }

    update_cardset(cardset) {
            this.set_cardset(cardset);
    }

    draw(pile_ui, coords, dz, animate) {
            if (this.animate != animate) return; // don't let piles update while animating
            this.coords = coords;
            this.update_face();
            this.set_position(pile_ui, {x:coords.x, y:coords.y, z:coords.z+(dz||0)}, !!animate);
            this.show();
            this.pile_ui = pile_ui;
    }

    coords_relative_to(pile_ui, dest_coords) {
            var c = this.coords, f = this.pile_ui.coords, t = pile_ui.coords;
            return { x: c.x + f.x - t.x, y: c.y + f.y - t.y, z: dest_coords.z };
    }


    animate_to(pile, offset, dz, callback) {
            var animating = this.animate;
            this.animate = { pile: pile, offset: offset, dz: dz||0, callback: (animating ? animating.callback : []).concat(callback ? [callback] : []) };
            if (animating) return;
            var next_frame = function(me, elapsed) {
                var d = me.animate, dc = me.animate.pile.coords(d.offset);
                if (me.pile_ui != me.animate.pile.ui)
                    me.draw(me.animate.pile.ui, me.coords_relative_to(me.animate.pile.ui, dc), 100+dz, me.animate); // switch to new pile without moving
                var dx = dc.x - me.coords.x, dy = dc.y - me.coords.y, r = 8 * Math.LN2 / 1000 / .250, rt = (r*elapsed)/(1+r*elapsed); // Backwards Euler
                if (Math.abs(dx) < 2/90 && Math.abs(dy) < 2/130) {
                    callback = me.animate.callback;
                    delete me.animate;
                    me.draw(d.pile.ui, dc, d.dz);
                    for (let c in callback) callback[c]();
                } else {
                    me.draw(d.pile.ui, { x: me.coords.x + rt * dx, y: me.coords.y + rt * dy, z: me.coords.z }, 100+d.dz, me.animate);
                    me.id = me.game.ui.request_animation_frame(function(elapsed) {
                        delete me.id;
                        next_frame(me, elapsed);
                    });
                }
            }

            next_frame(this, 0);
    }

    cancel_animation() {
            if (this.id != undefined) { this.game.ui.cancel_animation_frame(this.id); delete this.id }
            delete this.animate;
    }

    erase() {
            this.hide();
    }

    // Backend stuff:
    redraw() { throw "abstractish base class" }
    set_opacity(front, back) {  throw "abstractish base class" }
    set_face(face) { throw "abstractish base class" }
    hide() { throw "abstractish base class" }
    show() { throw "abstractish base class" }
    set_cardset(cardset) { throw "abstractish base class" }
    set_position(pile_ui, coords, animating) { throw "abstractish base class" }
    set_cursor(cursor) { throw "abstractish base class" }
}

function grid() {
    // Deep copy the grid from out of arguments.
    var g = []
    for (var r=0; r<arguments.length; r++)
        g[r] = arguments[r].slice();
    return { grid: g };
}

module.exports = {
    pile_game_ui: pile_game_ui,
    pile_ui: pile_ui,
    card_ui: card_ui,
    grid: grid,
    aspect: { 'phone_landscape' : 2/1,
              'phone_portrait'  : 1/2,
              'tablet_landscape': 3/4,
              'tablet_portrait' : 4/3, },
};
